import { Component, AfterViewInit, Inject, PLATFORM_ID, NgZone,HostListener } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';

declare var $: any;

@Component({
  selector: 'app-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.css']
})
export class HubComponent implements AfterViewInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private zone: NgZone
  ) {}

  isNavOpen = false;

  // navTog button click → toggle
  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  // Link click pe close
  closeNav(): void {
    this.isNavOpen = false;
  }

  // Nav ke bahar click pe close
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.unav')) {
      this.isNavOpen = false;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          const gallery = $('#gallery');
          const gallery1 = $('#gallery1');

          if (gallery.length && gallery1.length) {
            gallery.slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 4000,
              pauseOnHover: true,
              cssEase: 'linear',
              rtl: true,
              draggable: false,
              swipe: false,
              touchMove: false,
              responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 3 } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
              ],
            });

            gallery1.slick({
              slidesToShow: 6,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 4000,
              pauseOnHover: true,
              cssEase: 'linear',
              draggable: false,
              swipe: false,
              touchMove: false,
              responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 3 } },
                { breakpoint: 600, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
              ],
            });

            AOS.init({ duration: 1000, once: true });
          }
        }, 500);
      });
    }
  }
}
